import Phaser from 'phaser';
import { Tile } from '@pbl/digital-games-core/lib/core/Tile';

export class CrosswordTileSprite {
  private backgroundSprite: Phaser.GameObjects.Sprite;
  private letterSprite: Phaser.GameObjects.Sprite | null;
  private coverSprite?: Phaser.GameObjects.Sprite | null;
  private tile: Tile;


  constructor(tile: Tile, backgroundSprite: Phaser.GameObjects.Sprite, letterSprite: Phaser.GameObjects.Sprite | null, coverSprite: Phaser.GameObjects.Sprite | null) {
    this.tile = tile;
    this.backgroundSprite = backgroundSprite;
    this.letterSprite = letterSprite;
    this.coverSprite = coverSprite;
  }

  getTile() {
    return this.tile;
  }

  getBackgroundSprite() {
    return this.backgroundSprite;
  }

  getLetterSprite() {
    return this.letterSprite;
  }

  getCoverSprite() {
    return this.coverSprite;
  }

  removeCoverSprite(sceneChildren: any) {
    if (this.coverSprite !== null) {
      sceneChildren.remove(this.coverSprite);
      this.coverSprite = null;
    }
  }

  setBackgroundTexture(imageName: string) {
    this.backgroundSprite.setTexture(imageName);
  }

  setLetterTexture(imageName: string) {
    if (this.letterSprite !== null) {
      this.letterSprite.setTexture(imageName);
    }
  }
}